<template>
  <div class="chat-main">
    <!-- <div class="hidden-detail" @click="close">
      <i class="el-icon-close"></i>
    </div>-->
    <el-button
      @click="close"
      type="text"
      class="newBackBtn"
      icon="el-icon-arrow-left"
    >
      返回
    </el-button>
    <div class="clearfix"></div>
    <div class="title" style="text-align: left">病史小结</div>
    <div>
      <el-form status-icon ref="ruleForm" label-width="140px" class="ruleForm">
        <div class="ruleForm-part-0">
          <div class="flexBox">
            <el-form-item prop label="患者姓名:"></el-form-item>
            <el-form-item prop label="患者性别:"></el-form-item>
            <el-form-item prop label="患者年龄:"></el-form-item>
          </div>
          <div class="flexBox">
            <el-form-item prop label="病史小结时间:"></el-form-item>
            <el-form-item prop label="所属医生:"></el-form-item>
          </div>
        </div>
        <div>
          <el-form-item prop label="查体和辅助检查:"></el-form-item>
          <el-form-item prop label="基础疾病:"></el-form-item>
          <el-form-item prop label="并发症情况:"></el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'medicaHistory',
  props: {
    data: {
      type: Object,
      default: {
        formData: [],
        detailLimit: [
          {
            label: '发单企业',
            prop: 'customerName'
          },
          {
            label: '项目名称',
            prop: 'customerName'
          },
          {
            label: '药店',
            prop: 'customerName'
          },
          {
            label: '巡店时间',
            prop: 'customerName'
          },
          {
            label: '药店定位',
            prop: 'customerName'
          },
          {
            label: '产品名称',
            prop: 'customerName'
          },
          {
            label: '全国指导价',
            prop: 'customerName'
          },
          {
            label: '产品售价',
            prop: 'customerName'
          },
          {
            label: '陈列要求',
            prop: 'customerName'
          },
          {
            label: '陈列状态',
            prop: 'customerName'
          },
          {
            label: '陈列照片',
            prop: 'customerName',
            img: true
          }
        ]
      }
    }
  },
  methods: {
    close() {
      this.$router.back();
      // this.$parent.hideDetail()
      this.$parent.hideDetail();
    },
    handleFiles(str) {
      let list = [];
      if (!str || !this.data.formData.bingliFileName) {
        return list;
      }
      let nameList = this.data.formData.bingliFileName.split(',');
      let strList = str.split(',');
      for (let i = 0; i < strList.length; i++) {
        list.push({ src: strList[i], name: nameList[i] });
      }
      return list;
    },

    eventClose() {
      // 关闭窗口
      this.$emit('update:showUserAddEdit', false); // 逆向修改
    }
    //提交
  },
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
};
</script>

<style lang="scss" scoped>
.hidden-detail {
  float: right;
  width: 1em;
  font-size: 25px;
  height: 2em;
}
.ruleForm {
  &-part-0 {
    box-shadow: 0 2px 1px #d1d1d159;
    margin-bottom: 20px;
    & > .flexBox {
      display: flex;
    }
  }
}
.chat-main > .title {
  font-weight: 500;
  font-size: large;
  text-align: left;
  box-shadow: 0 2px 1px #d1d1d159;
  margin-bottom: 20px;
}
/*.chat-item {*/
/*  text-align: left;*/
/*  .content {*/
/*    padding: 20px 0;*/
/*    & > img {*/
/*      width: 300px;*/
/*      height: auto;*/
/*    }*/
/*  }*/
/*  .chat-item-title {*/
/*    & > div {*/
/*      display: inline-block;*/
/*    }*/
/*    .title {*/
/*      font-weight: bold;*/
/*      text-align: left;*/
/*    }*/
/*  }*/
/*}*/
</style>
